import { Box, styled } from '@mui/material';
import mcdArch from 'src/assets/images/McdArch.svg';

export const AuthLockWrapper = styled(Box)`
  #auth0-lock-container .auth0-lock-center {
    padding: 0;
    border: 1px solid #e0e0e0;
  }

  #auth0-lock-container .auth0-lock-widget {
    min-width: 400px;
  }

  #auth0-lock-container .auth0-lock-form {
    padding: 0;
  }

  #auth0-lock-container .auth0-lock-content-body-wrapper {
    padding-top: 20px;

    & p {
      color: #333333;
    }
  }

  #auth0-lock-container
    a.auth0-lock-social-button.auth0-lock-social-big-button {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffcc00;
    border-top: 1px solid #e0e0e0;
    height: 70px;

    &:hover {
      background-color: #f8c559;
    }

    &::after {
      content: '';
      position: absolute;
      right: 75px;
      top: 50%;
      width: 6px;
      height: 7px;
      border-top: 2px solid #e50102;
      border-right: 2px solid #e50102;
      transform: translateY(-50%) rotate(45deg);
    }

    .auth0-lock-social-button-icon {
      position: absolute;
      left: 55px;
      top: 50%;
      transform: translateY(-50%);
      width: 32px;
      height: 32px;
      background-image: url('${mcdArch}');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    .auth0-lock-social-button-text {
      display: flex;
      align-items: center;
      justify-content: center;
      height: inherit;
      font-size: 0;
      color: transparent;
      background-color: transparent;
    }

    .auth0-lock-social-button-text::after {
      content: "MCDONALD'S SINGLE SIGN ON";
      font-size: 14px;
      font-weight: 400;
      color: #e50102;
      visibility: visible;
      position: absolute;
      left: 0;
      right: 0;
      text-align: center;
    }
  }
`;
